// 1.

import React, { memo, useContext, Suspense, useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../context/AuthenticationContext";
import { BusinessAuthenticationContext } from "../context/BussinessAuthenticationContext";
import { Box } from "@mui/material";

import EventLogReports from "../pages/admin/page/event_log_reports/EventLogReports";
import MsitMain from "../pages/admin/page/msit/MsitMain";
import StringInverter from "../pages/admin/page/msit/stringInverter/StringInverter";
import PrivateRoute2 from "./stacks/PrivateRoute2";
import BusinessDashboard from "../pages/admin/page/business/BusinessDashboard";
import PlantPowerCurve from "../pages/admin/page/plantPowerCurve/PlantPowerCurve";
import PrAnalysis from "../pages/admin/page/prAnalysis/PrAnalysis";
import DashboardKusum from "../pages/admin/page/dashboardKusum/DashboardKusum";
import PlantPowerCurveKusum from "../pages/admin/page/plantPowerCurveKusum/PlantPowerCurveKusum";


import BusinessInner from "../pages/admin/page/businessInner/BusinessInner";
import Header2 from "../components/dashboard/Header2";

import BusinessGroupForm from "../pages/admin/page/business/businessGroupFrom/BusinessGroupForm";
import BusinessGroupListData from "../pages/admin/page/businessPageData/businessGroupList/businessGroupListData/BusinessGroupListData";
import BusinessGroupList from "../pages/admin/page/businessPageData/businessGroupList/BusinessGroupList";
import BusinessGroupListRight from "../pages/admin/page/businessPageData/businessGroupList/businessGroupListRight/BusinessGroupListRight";
import BusinessLocation from "../pages/admin/page/businessPageData/businessLocation/BusinessLocation";
import ControllingGroup from "../pages/admin/page/inverter/tabs_content/ControllingGroup";
import ControllingGroupBottom from "../pages/admin/page/businessPageData/controllingGroup/controllingGroupBottom/ControllingGroupBottom";
import ControllingGroupBusiness from "../pages/admin/page/businessPageData/controllingGroup/ControllingGroup";
import Dashboard7Location from "../pages/admin/page/dashboard/dashboardTabs/tab7LocationContent/Dashboard7Location";
import GeographicalLocation from "../pages/admin/page/geographicalLocation/GeographicalLocation";
import AlaramLog from "../pages/admin/page/alarmLog/AlaramLog";
import Plant1 from "../pages/admin/page/plantEnergy/plant1/Plant1";
import Plant2 from "../pages/admin/page/plantEnergy/plant2/Plant2";
import Plant3 from "../pages/admin/page/plantEnergy/plant3/Plant3";
import PlantMis from "../pages/admin/page/businessPageData/plantMis/PlantMis";
import TransformerHealth from "../pages/admin/page/transformerHealth/TransformerHealth";
import BusinessWms from "../pages/admin/page/businessPageData/businessWms/BusinessWms";
import BusinessInnerDashboard from "../pages/admin/page/businessInner/BusinessInnerDashboard";
import Battery from "../pages/admin/page/battery/Battery";
import BusinessGroupListMain from "../pages/admin/page/businessPageData/businessGroupList/BusinessGroupListMain";
import Analytics from "../pages/admin/page/Analytics/Analytics";
import UserAnalytics from "../pages/admin/page/UserAnalytics/UserAnalytics";
import SupportForm from "../pages/admin/page/SupportForm/SupportForm";
import SupportFormMain from "../pages/admin/page/SupportForm/SupportFormMain";
import UserDetails from "../pages/admin/page/UserDetails/UserDetails";
import Relay from "../pages/admin/page/Relay/Relay";
import IncomerFeeder from "../pages/admin/page/IncomerFeeder/IncomerFeeder";


const PrivateRoute = React.lazy(() => import("./stacks/PrivateRoute"));
const Dashboard = React.lazy(() => import("../pages/admin/page/dashboard/Dashboard"));
const Analysis = React.lazy(() => import("../pages/admin/page/analysis/Analysis"));
const PvMonitoring = React.lazy(() => import("../pages/admin/page/pv_monitoring/PvMonitoring"));
const WMS = React.lazy(() => import("../pages/admin/page/wms/WMS"));
const PublicRoute = React.lazy(() => import("./stacks/PublicRoute"));
const Login = React.lazy(() => import("../pages/auth/Login"));
const EnergyReporting = React.lazy(() => import("../pages/admin/page/energy_reporting/EnergyReporting"));
const Inverter = React.lazy(() => import("../pages/admin/page/inverter/Inverter"));
const Inverter1 = React.lazy(() => import("../pages/admin/page/inverter1/Inverter1"));
const Grid = React.lazy(() => import("../pages/admin/page/grid/Grid"));
const DG = React.lazy(() => import("../pages/admin/page/dg/DG"));
const EnergyMeter = React.lazy(() => import("../pages/admin/page/energy_meter/EnergyMeter"));
const SMB = React.lazy(() => import("../pages/admin/page/smb/SMB"));


// const MainRouter = () => {
//   const { IsLogged, LoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
//   const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
//   // const IsLoggedIn=localStorage.getItem("isLoggedIn")


//   const loginInfoData = localStorage.getItem("pass")

//   // console.log("IsLoggedMain:", IsLogged, "IsLoggedInMain:", IsLoggedIn);

//   if (authLoading || businessAuthLoading) {
//     return <div>Loading...</div>;  // or a spinner
//   }


//   return (
//     <Routes>

//       {/* 🔹 Default redirect to login if no path is matched */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       {/* 🔹 Public Routes (Login) */}
//       {!IsLogged && !IsLoggedIn ? (
//         <>
//           <Route path="/login" element={<PublicRoute />}>
//             <Route index element={<Login />} />
//             <Route path="*" element={<Navigate to="/login" replace />} />
//           </Route>

//         </>
//       ) : (
//         <>
//           {/* 🔹 Private Routes */}
//           {IsLogged && (
//             <>
//               {
//                 loginInfoData === "target" ?

//                   <Route path="/" element={<PrivateRoute />}>
//                     {
//                       loginInfoData === "target" ?
//                         <Route path="businessDashboard" element={<BusinessDashboard />} /> : null
//                     }

//                     {LoggedInUserInfo.USER_CATEGORY?.trim() === "KUSUM" ? (
//                       <Route path="userDashboard" element={<DashboardKusum />} />
//                     ) : LoggedInUserInfo.USER_CATEGORY?.trim() === "WMS" ? (
//                       <Route path="userDashboard" element={<WMS />} />
//                     ) : (
//                       <Route path="userDashboard" element={<Dashboard />} />
//                     )}



//                     {/* Redirect "/" to "/dashboard" */}
//                     <Route index element={<Navigate to="/userDashboard" />} />




//                     <Route path="wms" element={<WMS />} />
//                     <Route path="inverter" element={<Inverter />} />
//                     <Route path="analysis" element={<Analysis />} />
//                     <Route path="inv" element={<Inverter1 />} />
//                     <Route path="grid" element={<Grid />} />
//                     <Route path="dg" element={<DG />} />
//                     <Route path="energy-meter" element={<EnergyMeter />} />
//                     <Route path="smb" element={<SMB />} />
//                     <Route path="relay" element={<Relay />} />
//                     <Route path="pv_monitoring" element={<PvMonitoring />} />
//                     <Route path="energy" element={<EnergyReporting />} />
//                     <Route path="event-log-reports" element={<EventLogReports />} />
//                     <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//                     <Route path="PR-analysis" element={<PrAnalysis />} />
//                     <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//                     <Route path="dashbboardLocation" element={<Dashboard7Location />} />
//                     <Route path="alaramLog" element={<AlaramLog />} />
//                     <Route path="plant1" element={<Plant1 />} />
//                     <Route path="plant2" element={<Plant2 />} />
//                     <Route path="plant3" element={<Plant3 />} />
//                     <Route path="transformerHealth" element={<TransformerHealth />} />
//                     <Route path="battery" element={<Battery />} />
//                     <Route path="analytics" element={<UserAnalytics />} />
//                     <Route path="incomer" element={<IncomerFeeder />} />
//                     <Route path="supportform" element={<SupportFormMain />} />
//                     <Route path="userdetails" element={<UserDetails />} />

//                     <Route path="geographicalLocation" element={<GeographicalLocation />} />
//                     <Route path="*" element={<Box>Page Not Found (User)</Box>} />
//                   </Route>
//                   :
//                   <Route path="/" element={<PrivateRoute />}>
//                     {
//                       loginInfoData === "target" ?
//                         <Route path="businessDashboard" element={<BusinessDashboard />} /> : null
//                     }


//                     {LoggedInUserInfo.USER_CATEGORY?.trim() === "KUSUM" ? (
//                       <Route path="userDashboard" element={<DashboardKusum />} />
//                     ) : LoggedInUserInfo.USER_CATEGORY?.trim() === "WMS" ? (
//                       <Route path="userDashboard" element={<WMS />} />
//                     ) : (
//                       <Route path="userDashboard" element={<Dashboard />} />
//                     )}



//                     {/* Redirect "/" to "/dashboard" */}
//                     <Route index element={<Navigate to="/userDashboard" />} />

//                     <Route path="wms" element={<WMS />} />
//                     <Route path="inverter" element={<Inverter />} />
//                     <Route path="analysis" element={<Analysis />} />
//                     <Route path="inv" element={<Inverter1 />} />
//                     <Route path="grid" element={<Grid />} />
//                     <Route path="dg" element={<DG />} />
//                     <Route path="energy-meter" element={<EnergyMeter />} />
//                     <Route path="smb" element={<SMB />} />
//                     <Route path="relay" element={<Relay />} />
//                     <Route path="pv_monitoring" element={<PvMonitoring />} />
//                     <Route path="energy" element={<EnergyReporting />} />
//                     <Route path="event-log-reports" element={<EventLogReports />} />
//                     <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//                     <Route path="PR-analysis" element={<PrAnalysis />} />
//                     <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//                     <Route path="geographicalLocation" element={<GeographicalLocation />} />
//                     <Route path="alaramLog" element={<AlaramLog />} />
//                     <Route path="plant1" element={<Plant1 />} />
//                     <Route path="plant2" element={<Plant2 />} />
//                     <Route path="plant3" element={<Plant3 />} />
//                     <Route path="transformerHealth" element={<TransformerHealth />} />
//                     <Route path="battery" element={<Battery />} />
//                     <Route path="incomer" element={<IncomerFeeder />} />
//                     <Route path="analytics" element={<UserAnalytics />} />
//                     <Route path="userdetails" element={<UserDetails />} />
//                     <Route path="supportform" element={<SupportFormMain />} />

//                     <Route path="*" element={<Box>Page Not Found (User)</Box>} />
//                   </Route>
//               }
//             </>
//           )}
//           {
//             IsLoggedIn && (
//               <Route path="businessDashboard" element={<BusinessDashboard />}>
//                 {/* Redirect to 'businessinner' when visiting '/businessDashboard' */}
//                 <Route index element={<Navigate to="business" replace />} />
//                 <Route path="business" element={<BusinessInnerDashboard />} />

//                 <Route path="businessLocation" element={<BusinessLocation />} />
//                 <Route path="plantMis" element={<PlantMis />} />

//                 <Route path="businessWms" element={<BusinessWms />} />

//                 <Route path="businessGroupList" element={<BusinessGroupListMain />}>

//                   <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
//                 </Route>

//                 <Route path="controllingGroup" element={<ControllingGroupBusiness />}>

//                   <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
//                 </Route>
//                 <Route path="analytics" element={<Analytics />} />


//               </Route>


//             )}

//         </>
//       )}
//     </Routes>

//   );
// };

// export default MainRouter;

// 2.


// const MainRouter = () => {
//   const { IsLogged, LoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
//   const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
//   const loginInfoData = localStorage.getItem("pass");

//   if (authLoading || businessAuthLoading) {
//     return <div>Loading...</div>; // या कोई अच्छा स्पिनर डाल सकते हैं
//   }

//   return (
//     <Routes>
//       {/* 🔹 Default redirect to login */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       {/* 🔹 Public Routes (Login) */}
//       {!IsLogged && !IsLoggedIn ? (
//         <Route path="/login" element={<PublicRoute />}>
//           <Route index element={<Login />} />
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Route>
//       ) : (
//         <>
//           {/* 🔹 User Private Routes (अगर लॉग्ड इन है या बिजनेस से टारगेट होकर आया है) */}
//           {(IsLogged || loginInfoData === "target") && (
//             <Route path="/" element={<PrivateRoute />}>
//               {/* Business Dashboard का एक्सेस अगर 'target' है */}
//               {loginInfoData === "target" && (
//                 <Route path="businessDashboard" element={<BusinessDashboard />} />
//               )}

//               {/* Dynamic User Dashboard Selection */}
//               <Route
//                 path="userDashboard"
//                 element={
//                   LoggedInUserInfo?.USER_CATEGORY?.trim() === "KUSUM" ? (
//                     <DashboardKusum />
//                   ) : LoggedInUserInfo?.USER_CATEGORY?.trim() === "WMS" ? (
//                     <WMS />
//                   ) : (
//                     <Dashboard />
//                   )
//                 }
//               />

//               {/* Redirect "/" to "/userDashboard" */}
//               <Route index element={<Navigate to="/userDashboard" replace />} />

//               {/* Other User Routes */}
//               <Route path="wms" element={<WMS />} />
//               <Route path="inverter" element={<Inverter />} />
//               <Route path="analysis" element={<Analysis />} />
//               <Route path="inv" element={<Inverter1 />} />
//               <Route path="grid" element={<Grid />} />
//               <Route path="dg" element={<DG />} />
//               <Route path="energy-meter" element={<EnergyMeter />} />
//               <Route path="smb" element={<SMB />} />
//               <Route path="relay" element={<Relay />} />
//               <Route path="pv_monitoring" element={<PvMonitoring />} />
//               <Route path="energy" element={<EnergyReporting />} />
//               <Route path="event-log-reports" element={<EventLogReports />} />
//               <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//               <Route path="PR-analysis" element={<PrAnalysis />} />
//               <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//               <Route path="dashbboardLocation" element={<Dashboard7Location />} />
//               <Route path="alaramLog" element={<AlaramLog />} />
//               <Route path="plant1" element={<Plant1 />} />
//               <Route path="plant2" element={<Plant2 />} />
//               <Route path="plant3" element={<Plant3 />} />
//               <Route path="transformerHealth" element={<TransformerHealth />} />
//               <Route path="battery" element={<Battery />} />
//               <Route path="analytics" element={<UserAnalytics />} />
//               <Route path="incomer" element={<IncomerFeeder />} />
//               <Route path="supportform" element={<SupportFormMain />} />
//               <Route path="userdetails" element={<UserDetails />} />
//               <Route path="geographicalLocation" element={<GeographicalLocation />} />
//               <Route path="*" element={<div>Page Not Found (User)</div>} />
//             </Route>
//           )}

//           {/* 🔹 Business Private Routes */}
//           {IsLoggedIn && (
//             <Route path="businessDashboard" element={<BusinessDashboard />}>
//               <Route index element={<Navigate to="business" replace />} />
//               <Route path="business" element={<BusinessInnerDashboard />} />
//               <Route path="businessLocation" element={<BusinessLocation />} />
//               <Route path="plantMis" element={<PlantMis />} />
//               <Route path="businessWms" element={<BusinessWms />} />
//               <Route path="businessGroupList" element={<BusinessGroupListMain />}>
//                 <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
//               </Route>
//               <Route path="controllingGroup" element={<ControllingGroupBusiness />}>
//                 <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
//               </Route>
//               <Route path="analytics" element={<Analytics />} />
//             </Route>
//           )}
//         </>
//       )}
//     </Routes>
//   );
// };

// export default MainRouter;

// 4.latest correct code


// const MainRouter = () => {
//   // ✅ फिक्स: यहाँ setLoggedInUserInfo को भी डिस्ट्रक्चर किया ताकि स्टेट अपडेट हो सके
//   const { IsLogged, LoggedInUserInfo, setLoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
//   const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
  
//   // ✅ 1. 'localStorage' की जगह 'sessionStorage' से यूजर डेटा रीड करें
//   const sessionUserData = sessionStorage.getItem("LoggedInUserInfo");
//   const parsedUserData = sessionUserData ? JSON.parse(sessionUserData) : null;
//   const loginInfoData = localStorage.getItem("pass");

//   // ✅ 2. मल्टी-टैब आइसोलेशन लॉजिक: नए टैब में पूरा पैकेट सिंक करने के लिए
//   useEffect(() => {
//     const tmpData = localStorage.getItem("transfer_tmp_user");
    
//     if (tmpData && !sessionUserData) {
//       // पैकेट को अनपैक करें
//       const packet = JSON.parse(tmpData);
      
//       // नए टैब के sessionStorage में सारी चाबियां अलग-अलग सेट करें
//       sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(packet.userInfo));
//       sessionStorage.setItem("LoginID", packet.loginId || "");
//       sessionStorage.setItem("PW", packet.pw || "");
//       sessionStorage.setItem("LCODE", packet.lcode || "");
      
//       // टेम्परेरी ट्रांसफर पैकेट को तुरंत डिलीट करें ताकि डेटा लीक या मिक्स न हो
//       localStorage.removeItem("transfer_tmp_user"); 
      
//       // स्टेट अपडेट करें और रिफ्रेश करें ताकि ऐप को तुरंत डेटा मिल जाए
//       if (setLoggedInUserInfo) {
//         setLoggedInUserInfo(packet.userInfo);
//       }
      
//       window.location.reload(); 
//     }
//   }, [sessionUserData, setLoggedInUserInfo]);

//   if (authLoading || businessAuthLoading) {
//     return <div>Loading...</div>;
//   }

//   // ✅ तय करें कि यूजर एक्टिव है या नहीं (Context स्टेट से या डायरेक्ट sessionStorage से)
//   const isUserAuthenticated = IsLogged || !!parsedUserData;
//   const currentUserInfo = LoggedInUserInfo || parsedUserData;

//   return (
//     <Routes>
//       {/* Default redirect */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       {/* 🔹 Public Routes */}
//       {!isUserAuthenticated && !IsLoggedIn ? (
//         <Route path="/login" element={<PublicRoute />}>
//           <Route index element={<Login />} />
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Route>
//       ) : (
//         <>
//           {/* 🔹 User Private Routes */}
//           {(isUserAuthenticated || loginInfoData === "target") && (
//             <Route path="/" element={<PrivateRoute />}>
              
//               {loginInfoData === "target" && (
//                 <Route path="businessDashboard" element={<BusinessDashboard />} />
//               )}

//               {/* Dynamic Dashboard Selection */}
//               <Route
//                 path="userDashboard"
//                 element={
//                   currentUserInfo?.USER_CATEGORY?.trim() === "KUSUM" ? (
//                     <DashboardKusum />
//                   ) : currentUserInfo?.USER_CATEGORY?.trim() === "WMS" ? (
//                     <WMS />
//                   ) : (
//                     <Dashboard />
//                   )
//                 }
//               />

//               <Route index element={<Navigate to="/userDashboard" replace />} />

//               {/* बाकी के सारे यूजर राउट्स */}
//               <Route path="wms" element={<WMS />} />
//               <Route path="inverter" element={<Inverter />} />
//               <Route path="analysis" element={<Analysis />} />
//               <Route path="inv" element={<Inverter1 />} />
//               <Route path="grid" element={<Grid />} />
//               <Route path="dg" element={<DG />} />
//               <Route path="energy-meter" element={<EnergyMeter />} />
//               <Route path="smb" element={<SMB />} />
//               <Route path="relay" element={<Relay />} />
//               <Route path="pv_monitoring" element={<PvMonitoring />} />
//               <Route path="energy" element={<EnergyReporting />} />
//               <Route path="event-log-reports" element={<EventLogReports />} />
//               <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//               <Route path="PR-analysis" element={<PrAnalysis />} />
//               <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//               <Route path="dashbboardLocation" element={<Dashboard7Location />} />
//               <Route path="alaramLog" element={<AlaramLog />} />
//               <Route path="plant1" element={<Plant1 />} />
//               <Route path="plant2" element={<Plant2 />} />
//               <Route path="plant3" element={<Plant3 />} />
//               <Route path="transformerHealth" element={<TransformerHealth />} />
//               <Route path="battery" element={<Battery />} />
//               <Route path="analytics" element={<UserAnalytics />} />
//               <Route path="incomer" element={<IncomerFeeder />} />
//               <Route path="supportform" element={<SupportFormMain />} />
//               <Route path="userdetails" element={<UserDetails />} />
//               <Route path="geographicalLocation" element={<GeographicalLocation />} />
//               <Route path="*" element={<div>Page Not Found (User)</div>} />
//             </Route>
//           )}

//           {/* 🔹 Business Private Routes */}
//           {IsLoggedIn && (
//             <Route path="businessDashboard" element={<BusinessDashboard />}>
//               <Route index element={<Navigate to="business" replace />} />
//               <Route path="business" element={<BusinessInnerDashboard />} />
//               <Route path="businessLocation" element={<BusinessLocation />} />
//               <Route path="plantMis" element={<PlantMis />} />
//               <Route path="businessWms" element={<BusinessWms />} />
//               <Route path="businessGroupList" element={<BusinessGroupListMain />}>
//                 <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
//               </Route>
//               <Route path="controllingGroup" element={<ControllingGroupBusiness />}>
//                 <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
//               </Route>
//               <Route path="analytics" element={<Analytics />} />
//             </Route>
//           )}
//         </>
//       )}
//     </Routes>
//   );
// };

// export default MainRouter;

// 5.last correct code 


// const MainRouter = () => {
//   const { IsLogged, LoggedInUserInfo, setLoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
//   const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
  
//   // ✅ नई स्टेट: जब तक डेटा सिंक हो रहा है, तब तक ऐप को रोक कर रखने के लिए
//   const [isSyncing, setIsSyncing] = useState(true);

//   const sessionUserData = sessionStorage.getItem("LoggedInUserInfo");
//   const parsedUserData = sessionUserData ? JSON.parse(sessionUserData) : null;
//   const loginInfoData = localStorage.getItem("pass");

//   // ✅ डेटा सिंक लॉजिक (यह सबसे पहले चलना चाहिए)
//   useEffect(() => {
//     const tmpData = localStorage.getItem("transfer_tmp_user");
    
//     if (tmpData && !sessionUserData) {
//       try {
//         const packet = JSON.parse(tmpData);
        
//         // sessionStorage में सारा डेटा डालें
//         sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(packet.userInfo));
//         sessionStorage.setItem("LoginID", packet.loginId || "");
//         sessionStorage.setItem("PW", packet.pw || "");
//         sessionStorage.setItem("LCODE", packet.lcode || "");
        
//         // ट्रांसफर पैकेट को तुरंत साफ करें
//         localStorage.removeItem("transfer_tmp_user"); 
        
//         if (setLoggedInUserInfo) {
//           setLoggedInUserInfo(packet.userInfo);
//         }
        
//         // डेटा सिंक हो गया, अब पेज रीलोड करें ताकि पूरा ऐप फ्रेश स्टेट ले सके
//         window.location.reload();
//         return;
//       } catch (e) {
//         console.error("Error parsing sync data", e);
//       }
//     }
    
//     // अगर कोई नया डेटा ट्रांसफर के लिए नहीं है, तो सिंकिंग बंद करें
//     setIsSyncing(false);
//   }, [sessionUserData, setLoggedInUserInfo]);

//   // ✅ जब तक लोडिंग या सिंकिंग चल रही है, ब्लैंक वाइट स्क्रीन की जगह 'Loading...' दिखाएं
//   if (authLoading || businessAuthLoading || isSyncing) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '18px', fontWeight: 'bold' }}>
//         System Configuration Loading...
//       </div>
//     );
//   }

//   const isUserAuthenticated = IsLogged || !!parsedUserData;
//   const currentUserInfo = LoggedInUserInfo || parsedUserData;

//   return (
//     <Routes>
//       {/* Default redirect */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       {/* 🔹 Public Route (Login) */}
//       <Route path="/login" element={<PublicRoute />}>
//         <Route index element={<Login />} />
//       </Route>

//       {/* 🔹 Private Routes Condition */}
//       {isUserAuthenticated || IsLoggedIn || loginInfoData === "target" ? (
//         <>
//           {/* 🔹 User Private Routes */}
//           {(isUserAuthenticated || loginInfoData === "target") && (
//             <Route path="/" element={<PrivateRoute />}>
              
//               {loginInfoData === "target" && (
//                 <Route path="businessDashboard" element={<BusinessDashboard />} />
//               )}

//               <Route
//                 path="userDashboard"
//                 element={
//                   currentUserInfo?.USER_CATEGORY?.trim() === "KUSUM" ? (
//                     <DashboardKusum />
//                   ) : currentUserInfo?.USER_CATEGORY?.trim() === "WMS" ? (
//                     <WMS />
//                   ) : (
//                     <Dashboard />
//                   )
//                 }
//               />

//               <Route index element={<Navigate to="/userDashboard" replace />} />

//               {/* आपके बाकी सभी यूजर राउट्स */}
//               <Route path="wms" element={<WMS />} />
//               <Route path="inverter" element={<Inverter />} />
//               <Route path="analysis" element={<Analysis />} />
//               <Route path="inv" element={<Inverter1 />} />
//               <Route path="grid" element={<Grid />} />
//               <Route path="dg" element={<DG />} />
//               <Route path="energy-meter" element={<EnergyMeter />} />
//               <Route path="smb" element={<SMB />} />
//               <Route path="relay" element={<Relay />} />
//               <Route path="pv_monitoring" element={<PvMonitoring />} />
//               <Route path="energy" element={<EnergyReporting />} />
//               <Route path="event-log-reports" element={<EventLogReports />} />
//               <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//               <Route path="PR-analysis" element={<PrAnalysis />} />
//               <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//               <Route path="dashbboardLocation" element={<Dashboard7Location />} />
//               <Route path="alaramLog" element={<AlaramLog />} />
//               <Route path="plant1" element={<Plant1 />} />
//               <Route path="plant2" element={<Plant2 />} />
//               <Route path="plant3" element={<Plant3 />} />
//               <Route path="transformerHealth" element={<TransformerHealth />} />
//               <Route path="battery" element={<Battery />} />
//               <Route path="analytics" element={<UserAnalytics />} />
//               <Route path="incomer" element={<IncomerFeeder />} />
//               <Route path="supportform" element={<SupportFormMain />} />
//               <Route path="userdetails" element={<UserDetails />} />
//               <Route path="geographicalLocation" element={<GeographicalLocation />} />
//               <Route path="*" element={<Navigate to="/userDashboard" replace />} />
//             </Route>
//           )}

//           {/* 🔹 Business Private Routes */}
//           {IsLoggedIn && (
//             <Route path="businessDashboard" element={<BusinessDashboard />}>
//               <Route index element={<Navigate to="business" replace />} />
//               <Route path="business" element={<BusinessInnerDashboard />} />  
//               <Route path="businessLocation" element={<BusinessLocation />} />
//               <Route path="plantMis" element={<PlantMis />} />
//               <Route path="businessWms" element={<BusinessWms />} />
//               <Route path="businessGroupList" element={<BusinessGroupListMain />}>
//                 <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
//               </Route>
//               <Route path="controllingGroup" element={<ControllingGroupBusiness />}>
//                 <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
//               </Route>
//               <Route path="analytics" element={<Analytics />} />
//               <Route path="*" element={<Navigate to="business" replace />} />
//             </Route>
//           )}
//         </>
//       ) : (
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       )}
//     </Routes>
//   );
// };

// export default MainRouter;

// 6. last correct code 14-july




// const MainRouter = () => {
//   const { IsLogged, LoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
//   const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
  
//   const loginInfoData = localStorage.getItem("pass");

//   // 🔹 जब तक कोई भी कॉन्टेक्स्ट लोड हो रहा है, लोडर दिखाएं
//   if (authLoading || businessAuthLoading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '18px', fontWeight: 'bold' }}>
//         System Configuration Loading...
//       </div>
//     );
//   }

//   // ऑथेंटिकेशन फ्लैग्स (IsLogged अब स्टेट से ही बिल्कुल सही स्टेट पकड़ेगा)
//   const isUserAuthenticated = IsLogged || !!LoggedInUserInfo;

//   return (
//     <Routes>
//       {/* Default redirect */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       {/* Public Route */}
//       <Route path="/login" element={<PublicRoute />}>
//         <Route index element={<Login />} />
//       </Route>

//       {/* Private Routes Condition */}
//       {isUserAuthenticated || IsLoggedIn || loginInfoData === "target" ? (
//         <>
//           {/* User Private Routes */}
//           {(isUserAuthenticated || loginInfoData === "target") && (
//             <Route path="/" element={<PrivateRoute />}>
              
//               {loginInfoData === "target" && (
//                 <Route path="businessDashboard" element={<BusinessDashboard />} />
//               )}

//               <Route
//                 path="userDashboard"
//                 element={
//                   LoggedInUserInfo?.USER_CATEGORY?.trim() === "KUSUM" ? (
//                     <DashboardKusum />
//                   ) : LoggedInUserInfo?.USER_CATEGORY?.trim() === "WMS" ? (
//                     <WMS />
//                   ) : (
//                     <Dashboard />
//                   )
//                 }
//               />

//               <Route index element={<Navigate to="/userDashboard" replace />} />

//               {/* आपके बाकी सभी यूजर राउट्स */}
//               <Route path="wms" element={<WMS />} />
//               <Route path="inverter" element={<Inverter />} />
//               <Route path="analysis" element={<Analysis />} />
//               <Route path="inv" element={<Inverter1 />} />
//               <Route path="grid" element={<Grid />} />
//               <Route path="dg" element={<DG />} />
//               <Route path="energy-meter" element={<EnergyMeter />} />
//               <Route path="smb" element={<SMB />} />
//               <Route path="relay" element={<Relay />} />
//               <Route path="pv_monitoring" element={<PvMonitoring />} />
//               <Route path="energy" element={<EnergyReporting />} />
//               <Route path="event-log-reports" element={<EventLogReports />} />
//               <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//               <Route path="PR-analysis" element={<PrAnalysis />} />
//               <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//               <Route path="dashbboardLocation" element={<Dashboard7Location />} />
//               <Route path="alaramLog" element={<AlaramLog />} />
//               <Route path="plant1" element={<Plant1 />} />
//               <Route path="plant2" element={<Plant2 />} />
//               <Route path="plant3" element={<Plant3 />} />
//               <Route path="transformerHealth" element={<TransformerHealth />} />
//               <Route path="battery" element={<Battery />} />
//               <Route path="analytics" element={<UserAnalytics />} />
//               <Route path="incomer" element={<IncomerFeeder />} />
//               <Route path="supportform" element={<SupportFormMain />} />
//               <Route path="userdetails" element={<UserDetails />} />
//               <Route path="geographicalLocation" element={<GeographicalLocation />} />
//               <Route path="*" element={<Navigate to="/userDashboard" replace />} />
//             </Route>
//           )}

//           {/* Business Private Routes */}
//           {IsLoggedIn && (
//             <Route path="businessDashboard" element={<BusinessDashboard />}>
//               <Route index element={<Navigate to="business" replace />} />
//               <Route path="business" element={<BusinessInnerDashboard />} />  
//               <Route path="businessLocation" element={<BusinessLocation />} />
//               <Route path="plantMis" element={<PlantMis />} />
//               <Route path="businessWms" element={<BusinessWms />} />
//               <Route path="businessGroupList" element={<BusinessGroupListMain />}>
//                 <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
//               </Route>
//               <Route path="controllingGroup" element={<ControllingGroupBusiness />}>
//                 <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
//               </Route>
//               <Route path="analytics" element={<Analytics />} />
//               <Route path="*" element={<Navigate to="business" replace />} />
//             </Route>
//           )}
//         </>
//       ) : (
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       )}
//     </Routes>
//   );
// };

// export default MainRouter;

// 7.

const MainRouter = () => {
  const { IsLogged, LoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
  const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
  
  // 🟢 लाइव फिक्स: सिर्फ इसी टैब के sessionStorage फ्लैग को चेक करें
  const isImpersonatedUser = sessionStorage.getItem("user_is_impersonated") === "true";

  if (authLoading || businessAuthLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '18px', fontWeight: 'bold' }}>
        System Configuration Loading...
      </div>
    );
  }

  // लाइव फिक्स: स्टेट के साथ-साथ डायरेक्ट sessionStorage का बैकअप भी चेक करें
  const sessionUserRaw = sessionStorage.getItem("LoggedInUserInfo");
  const fallbackUser = sessionUserRaw ? JSON.parse(sessionUserRaw) : null;
  
  const activeUserInfo = LoggedInUserInfo || fallbackUser;
  const isUserAuthenticated = IsLogged || !!activeUserInfo;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Public Route */}
      <Route path="/login" element={<PublicRoute />}>
        <Route index element={<Login />} />
      </Route>

      {/* Private Routes Condition */}
      {isUserAuthenticated || IsLoggedIn || isImpersonatedUser ? (
        <>
          {/* User Private Routes */}
          {(isUserAuthenticated || isImpersonatedUser) && (
            <Route path="/" element={<PrivateRoute />}>
              
              {/* 🟢 लाइव फिक्स: अगर बिज़नेस टैब से रिक्वेस्ट आई है, तो इसे रूट लेवल एक्सेस दें */}
              {isImpersonatedUser && (
                <Route path="businessDashboard" element={<BusinessDashboard />} />
              )}

              <Route
                path="userDashboard"
                element={
                  activeUserInfo?.USER_CATEGORY?.trim() === "KUSUM" ? (
                    <DashboardKusum />
                  ) : activeUserInfo?.USER_CATEGORY?.trim() === "WMS" ? (
                    <WMS />
                  ) : (
                    <Dashboard />
                  )
                }
              />

              <Route index element={<Navigate to="/userDashboard" replace />} />

              {/* बाकी सभी यूजर राउट्स */}
              <Route path="wms" element={<WMS />} />
              <Route path="inverter" element={<Inverter />} />
              <Route path="analysis" element={<Analysis />} />
              <Route path="inv" element={<Inverter1 />} />
              <Route path="grid" element={<Grid />} />
              <Route path="dg" element={<DG />} />
              <Route path="energy-meter" element={<EnergyMeter />} />
              <Route path="smb" element={<SMB />} />
              <Route path="relay" element={<Relay />} />
              <Route path="pv_monitoring" element={<PvMonitoring />} />
              <Route path="energy" element={<EnergyReporting />} />
              <Route path="event-log-reports" element={<EventLogReports />} />
              <Route path="plant-power-curve" element={<PlantPowerCurve />} />
              <Route path="PR-analysis" element={<PrAnalysis />} />
              <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
              <Route path="dashbboardLocation" element={<Dashboard7Location />} />
              <Route path="alaramLog" element={<AlaramLog />} />
              <Route path="plant1" element={<Plant1 />} />
              <Route path="plant2" element={<Plant2 />} />
              <Route path="plant3" element={<Plant3 />} />
              <Route path="transformerHealth" element={<TransformerHealth />} />
              <Route path="battery" element={<Battery />} />
              <Route path="analytics" element={<UserAnalytics />} />
              <Route path="incomer" element={<IncomerFeeder />} />
              <Route path="supportform" element={<SupportFormMain />} />
              <Route path="userdetails" element={<UserDetails />} />
              <Route path="geographicalLocation" element={<GeographicalLocation />} />
              <Route path="*" element={<Navigate to="/userDashboard" replace />} />
            </Route>
          )}

          {/* Business Private Routes */}
          {IsLoggedIn && (
            <Route path="businessDashboard" element={<BusinessDashboard />}>
              <Route index element={<Navigate to="business" replace />} />
              <Route path="business" element={<BusinessInnerDashboard />} />  
              <Route path="businessLocation" element={<BusinessLocation />} />
              <Route path="plantMis" element={<PlantMis />} />
              <Route path="businessWms" element={<BusinessWms />} />
              <Route path="businessGroupList" element={<BusinessGroupListMain />}>
                <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
              </Route>
              <Route path="controllingGroup" element={<ControllingGroupBusiness />}>
                <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
              </Route>
              <Route path="analytics" element={<Analytics />} />
              <Route path="*" element={<Navigate to="business" replace />} />
            </Route>
          )}
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
};

export default MainRouter;